import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { DayOfWeekItem } from '@/models/dictionary/day-of-week.model';

export default class GetDayOfWeekRequest extends ApiResourceMethod<DayOfWeekItem[]> {
  public perform(): Promise<DayOfWeekItem[]> {
    return this.performer.requestWithMapper(
      {},
      ({ data }: BaseResponse<DayOfWeekItem[]>) => data,
    );
  }
}
